import { AiFillHome } from "@react-icons/all-files/ai/AiFillHome";
import { AiOutlineInstagram } from "@react-icons/all-files/ai/AiOutlineInstagram";
import { ImFacebook } from "@react-icons/all-files/im/ImFacebook";
import { ImLinkedin2 } from "@react-icons/all-files/im/ImLinkedin2";
import { ImPhone } from "@react-icons/all-files/im/ImPhone";
import { ImTwitter } from "@react-icons/all-files/im/ImTwitter";
import { ImYoutube } from "@react-icons/all-files/im/ImYoutube";
import { IoIosMail } from "@react-icons/all-files/io/IoIosMail";
import LKCTCLogo from "../../assets/images/LKCTC-LOGO.png";
import { Link } from "react-router-dom";
import React from "react";
import locSchoolOfEngineering from "../../assets/pdf/locSchoolOfEngineering.pdf";

const Footer = () => {
  const icons = [
    {
      svgs: <ImFacebook className=" text-white w-5 h-auto" />,
      id: "facebook",
      links: "https://www.facebook.com/LKCTCJAL",
    },
    {
      svgs: <ImLinkedin2 className=" fill-white w-5 h-auto" />,
      id: "linkedin",
      links:
        "https://www.linkedin.com/in/lyallpur-khalsa-college-technical-campus-lkctc-jalandhar-9551a4296/",
    },
    {
      svgs: <AiOutlineInstagram className=" text-white  w-5 h-auto" />,
      id: "instagram",
      links: "https://www.instagram.com/lkctcjalandhar/",
    },
    {
      svgs: <ImYoutube className=" text-white  w-5 h-auto" />,
      id: "youtube",
      links: "https://www.youtube.com/@LKCTC-Jalandhar",
    },
  ];
  const word = {
    INFORMATION: [
      { title: "Home", id: "1", url: "/" },
      { title: "About Us", id: "2", url: "/About/AboutLKCTC" },
      { title: "Gallery", id: "3", url: "/PhotoGallery" },
      { title: "Academics", id: "4", url: "/academics/listOfCourses" },
      {
        title: "Admissions",
        id: "5",
        redirect: "http://lkctc.edu.in/Admission/AdmissionForm",
        // "https://docs.google.com/forms/d/e/1FAIpQLScCEWfZ0a0KlfcLL0LGSbjKq9BFN6CDAWaqReIqzhWQv830lQ/viewform",
        // "https://tinyurl.com/LKCTCAdmissionReg2025",
      },
      { title: "Contact Us", id: "6", url: "/Contact" },
    ],

    COURSES: [
      {
        title: "School Of Engineering & Healthcare Sciences",
        id: "1",
        url: "/Academics/DepartmentOfCivilEngineering",
      },
      {
        title: "School of Health Science",
        id: "2",
        url: "/Academics/DepartmentOfHealthScience",
      },
      {
        title: "School of Management",
        id: "3",
        url: "/Academics/ManagementDepartment",
      },
      { title: "School of IT", id: "4", url: "/Academics/DepartmentOfIT" },
      {
        title: "School of Hotel Management ",
        id: "5",
        url: "/Academics/DepartmentOfHotelManagement",
      },
      {
        id: "6",
        title: "List of Committees",
        url: "",
      },
      {
        id: "7",
        title: "School of Engineering",
        pdf: locSchoolOfEngineering,
      },
      {
        id: "8",
        title: "KCLIMT",
        url: "",
      },
      {
        id: "9",
        title: "School of Pharmacy",
        url: "http://pharmacy.lkctc.edu.in/",
      },
    ],

    ADDRESS: [
      {
        title: `Lyallpur Khalsa College Technical Campus Cantt Road, Jalandhar (Pb)-144001`,
        id: "1",
        svg: <AiFillHome className="w-6 h-auto" />,
      },
      {
        title: "info@lkcengg.edu.in",
        id: "2",
        svg: <IoIosMail className="w-6 h-auto" />,
      },
      {
        title:
          "+91 8847262500, +91 9872476060, +91 9646904005,+91 9814610383 +91-181-2350400/402/403 ",
        id: "3",
        svg: <ImPhone className="w-6 h-auto" />,
      },
    ],
  };

  return (
    <div className="bannerBotttom mt-16 border pb-2 pt-10">
      <div className="mx-auto grid w-[95%] grid-cols-1 gap-5 xl:gap-10 pb-16 px-3 md:grid-cols-2 lg:grid-cols-5 xl:px-5">
        <div className="">
          <div className="relative h-[60px] w-[60px] md:h-[80px] md:w-[80px] xl:h-[120px] xl:w-[120px]">
            <img src={LKCTCLogo} alt="" layout="fill" />
          </div>
          <div>
            <p className="py-4 text-start text-white text-sm md:text-md">
              The Lyallpur Khalsa College Technical Campus was established with
              the merger of two distinguished colleges in the region, namely,
              the Khalsa College Lyallpur Institute of Management & Technology.
            </p>
          </div>
          <div className="flex gap-1 md:gap-2 lg:gap-0 xl:gap-4">
            {icons?.map((item) => (
              <a
                href={item?.links}
                target="_blank"
                key={item?.id}
                rel="noreferrer"
              >
                <div className="rounded-full border border-blue-600 from-[#081C3A] to-[#32727A] p-2 hover:bg-gradient-to-b  ">
                  {item?.svgs}
                </div>
              </a>
            ))}
          </div>
        </div>

        {Object.keys(word)?.map((item) => (
          <div key={item} className=" border-red-500 ">
            <div className="pb-6 text-lg xl:text-xl font-semibold uppercase text-white">
              {item}
            </div>
            <ul className="space-y-2 ">
              {word[item]?.map((items) => (
                <li
                  className="flex gap-3 xl:gap-4 lg:text-lg text-white text-sm md:text-lg "
                  key={items?.title}
                >
                  {items?.svg && <div>{items?.svg}</div>}

                  {item === "ADDRESS" ? (
                    <div className=" xxs:text-sm md:text-md">
                      {items?.title}
                    </div>
                  ) : items?.redirect ? (
                    <a
                      className="hover:text-[#32727A] text-sm md:text-lg lg:text-start"
                      href={items?.redirect}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {items?.title}
                    </a>
                  ) : items?.title === "List of Committees" ? (
                    <div className="py-2 text-lg xl:text-xl font-semibold uppercase text-white">
                      {items?.title}
                    </div>
                  ) : (
                    <button
                      className="hover:text-[#32727A] text-sm md:text-lg lg:text-start"
                      onClick={() => window.scroll(0, 0)}
                    >
                      <a href={items?.pdf} target="_blank" rel="noreferrer">
                        {items?.title}
                      </a>
                    </button>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
        {/* Native Social Connect Section */}
        <div className="flex flex-col justify-start w-full">
          <div className="pb-4 text-lg xl:text-xl font-semibold uppercase text-white tracking-wide">
            CONNECT WITH US
          </div>
          <div className="flex flex-col gap-2.5">
            {/* Facebook 1 - Main Campus */}
            <a
              href="https://www.facebook.com/LKCTCJAL"
              target="_blank"
              rel="noreferrer"
              className="group flex items-center justify-between p-2.5 rounded-xl bg-white/5 hover:bg-[#1877F2]/20 border border-white/10 hover:border-[#1877F2]/60 transition-all duration-300 shadow-md"
            >
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg bg-[#1877F2] flex items-center justify-center text-white shadow-md group-hover:scale-105 transition-transform shrink-0">
                  <ImFacebook className="w-4 h-4 text-white" />
                </div>
                <div className="text-left overflow-hidden">
                  <p className="text-white font-medium text-xs md:text-sm leading-snug group-hover:text-[#38bdf8] transition-colors truncate">
                    Facebook (LKCTC)
                  </p>
                  <p className="text-gray-300 text-[11px] truncate">@LKCTCJAL</p>
                </div>
              </div>
              <span className="text-[11px] font-medium text-[#38bdf8] opacity-90 group-hover:translate-x-0.5 transition-all shrink-0 ml-1">
                Follow &rarr;
              </span>
            </a>

            {/* Facebook 2 - Engineering */}
            <a
              href="https://www.facebook.com/LKCEngg"
              target="_blank"
              rel="noreferrer"
              className="group flex items-center justify-between p-2.5 rounded-xl bg-white/5 hover:bg-[#1877F2]/20 border border-white/10 hover:border-[#1877F2]/60 transition-all duration-300 shadow-md"
            >
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg bg-[#1877F2]/80 flex items-center justify-center text-white shadow-md group-hover:scale-105 transition-transform shrink-0">
                  <ImFacebook className="w-4 h-4 text-white" />
                </div>
                <div className="text-left overflow-hidden">
                  <p className="text-white font-medium text-xs md:text-sm leading-snug group-hover:text-[#38bdf8] transition-colors truncate">
                    Facebook (LKCEngg)
                  </p>
                  <p className="text-gray-300 text-[11px] truncate">@LKCEngg</p>
                </div>
              </div>
              <span className="text-[11px] font-medium text-[#38bdf8] opacity-90 group-hover:translate-x-0.5 transition-all shrink-0 ml-1">
                Follow &rarr;
              </span>
            </a>

            {/* Instagram */}
            <a
              href="https://www.instagram.com/lkctcjalandhar/"
              target="_blank"
              rel="noreferrer"
              className="group flex items-center justify-between p-2.5 rounded-xl bg-white/5 hover:bg-pink-600/20 border border-white/10 hover:border-pink-500/50 transition-all duration-300 shadow-md"
            >
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg bg-gradient-to-tr from-amber-500 via-rose-500 to-purple-600 flex items-center justify-center text-white shadow-md group-hover:scale-105 transition-transform shrink-0">
                  <AiOutlineInstagram className="w-4 h-4 text-white" />
                </div>
                <div className="text-left overflow-hidden">
                  <p className="text-white font-medium text-xs md:text-sm leading-snug group-hover:text-pink-400 transition-colors truncate">
                    Instagram
                  </p>
                  <p className="text-gray-300 text-[11px] truncate">@lkctcjalandhar</p>
                </div>
              </div>
              <span className="text-[11px] font-medium text-pink-400 opacity-90 group-hover:translate-x-0.5 transition-all shrink-0 ml-1">
                Follow &rarr;
              </span>
            </a>

            {/* LinkedIn */}
            <a
              href="https://www.linkedin.com/in/lyallpur-khalsa-college-technical-campus-lkctc-jalandhar-9551a4296/"
              target="_blank"
              rel="noreferrer"
              className="group flex items-center justify-between p-2.5 rounded-xl bg-white/5 hover:bg-[#0A66C2]/20 border border-white/10 hover:border-[#0A66C2]/60 transition-all duration-300 shadow-md"
            >
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg bg-[#0A66C2] flex items-center justify-center text-white shadow-md group-hover:scale-105 transition-transform shrink-0">
                  <ImLinkedin2 className="w-3.5 h-3.5 text-white" />
                </div>
                <div className="text-left overflow-hidden">
                  <p className="text-white font-medium text-xs md:text-sm leading-snug group-hover:text-blue-400 transition-colors truncate">
                    LinkedIn Network
                  </p>
                  <p className="text-gray-300 text-[11px] truncate">LKCTC Jalandhar</p>
                </div>
              </div>
              <span className="text-[11px] font-medium text-blue-400 opacity-90 group-hover:translate-x-0.5 transition-all shrink-0 ml-1">
                Connect &rarr;
              </span>
            </a>

            {/* YouTube */}
            <a
              href="https://www.youtube.com/@LKCTC-Jalandhar"
              target="_blank"
              rel="noreferrer"
              className="group flex items-center justify-between p-2.5 rounded-xl bg-white/5 hover:bg-[#FF0000]/20 border border-white/10 hover:border-[#FF0000]/60 transition-all duration-300 shadow-md"
            >
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg bg-[#FF0000] flex items-center justify-center text-white shadow-md group-hover:scale-105 transition-transform shrink-0">
                  <ImYoutube className="w-3.5 h-3.5 text-white" />
                </div>
                <div className="text-left overflow-hidden">
                  <p className="text-white font-medium text-xs md:text-sm leading-snug group-hover:text-red-400 transition-colors truncate">
                    YouTube Channel
                  </p>
                  <p className="text-gray-300 text-[11px] truncate">@LKCTC-Jalandhar</p>
                </div>
              </div>
              <span className="text-[11px] font-medium text-red-400 opacity-90 group-hover:translate-x-0.5 transition-all shrink-0 ml-1">
                Watch &rarr;
              </span>
            </a>
          </div>
        </div>
      </div>{" "}
      <div className="">
        <div className="w-full border-t pt-2" />
      </div>
      <footer className="text-center text-white xxs:text-sm">
        <p>
          Copyright &copy; {new Date().getFullYear()} Lyallpur Khalsa College
          Technical Campus
        </p>
      </footer>
    </div>
  );
};
export default Footer;
